import React, { useState, useEffect, lazy, Suspense } from "react"

import {
  getTablasGeneralesByNro,
  getTablaGeneralConfig,
  getTablasGeneralesCatalogos,
  getFilasTablaExterna,
} from "api"
import toastHandler from "toastHandler"

import Layout from "components/Layout"
import TablasGenerales from "./TablasGenerales"

import { useLocation } from "react-router-dom"

const COMPONENTES_ESPECIALES = {
  Entidades: lazy(() => import("pages/Agro/Configuracion/Catalogos/Entidades")),
}

const Index = () => {
  const { setError } = toastHandler()
  const { search } = useLocation()
  const nro = new URLSearchParams(search).get("nro")

  const [tablas, setTablas] = useState([])
  const [config, setConfig] = useState(null)
  const [title, setTitle] = useState("")
  const [loadingTablas, setLoadingTablas] = useState(true)
  const [loadingTitle, setLoadingTitle] = useState(true)
  const loading = loadingTablas || loadingTitle
  const [action, setAction] = useState(false)
  const [incluirInactivos, setIncluirInactivos] = useState(false)

  useEffect(() => {
    setLoadingTablas(true)
    if (nro) {
      setLoadingTitle(true)
      getTablaGeneralConfig(nro)
        .then(cfg => {
          setConfig(cfg)
          setTitle(cfg?.titulo || cfg?.descripcion || `Tabla ${nro}`)
          setLoadingTitle(false)
          const fetchFilas =
            cfg?.tipoCatalogo === "TABLA_EXTERNA"
              ? getFilasTablaExterna(nro)
              : getTablasGeneralesByNro(nro, incluirInactivos)
          fetchFilas
            .then(setTablas)
            .catch(setError)
            .finally(() => setLoadingTablas(false))
        })
        .catch(err => {
          setError(err)
          setLoadingTitle(false)
          setLoadingTablas(false)
        })
    } else {
      setConfig(null)
      getTablasGeneralesCatalogos(incluirInactivos)
        .then(setTablas)
        .catch(setError)
        .finally(() => setLoadingTablas(false))
    }
  }, [nro, action, incluirInactivos])

  const ComponenteEspecial = config?.nombreComponente
    ? COMPONENTES_ESPECIALES[config.nombreComponente]
    : null

  const components = [
    {
      component: ComponenteEspecial ? (
        <Suspense fallback={<div style={{ padding: 20 }}>Cargando...</div>}>
          {React.createElement(ComponenteEspecial)}
        </Suspense>
      ) : (
        <TablasGenerales
          {...{
            tablas,
            nro,
            config,
            loading,
            action,
            setAction,
            incluirInactivos,
            setIncluirInactivos,
          }}
        />
      ),
    },
  ]

  return (
    <Layout
      title={
        nro
          ? loading
            ? ""
            : `Catálogo de Tablas: ${title}`
          : "Catálogo de Tablas"
      }
      components={components}
      loading={nro ? loading : loadingTablas}
    />
  )
}

export default Index
